import { Lightning, Log } from '@lightningjs/sdk';
import { ButtonConstant } from './ButtonConstants';
import { Theme } from '../../config/theme';

export class RatingButton extends Lightning.Component {
  static _template() {
    return {
      h: ButtonConstant.defaultH,
      flex: {
        direction: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingLeft: ButtonConstant.horizontalPadding,
        paddingRight: ButtonConstant.horizontalPadding,
      },
      Background: {
        flexItem: false,
        w: w => w,
        h: h => h,
        rect: true,
        color: Theme.Colors.Button.TextButton.Active.Fill,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: ButtonConstant.cornerRadius,
          stroke: ButtonConstant.stroke,
          strokeColor: Theme.Colors.Button.Primary.Normal.Border,
        },
      },
      Label: {
        text: {
          offsetY: 64,
          ...Theme.Fonts.Bold,
          wordWrap: false,
          verticalAlign: 'middle',
          textOverflow: 'ellipsis',
          color: Theme.Colors.Button.Primary.Normal.Text,
        },
      },
      Icon: {
        visible: false,
      },
    };
  }

  get label() {
    return this.tag('Label').text.text;
  }

  set label(label) {
    this.tag('Label').text.text = label;
  }

  set icon(icon) {
    const hasIcon = !!icon;
    this.tag('Icon').visible = hasIcon;
    this.tag('Label').visible = !hasIcon;
    this.tag('Icon').src = icon;
    this._normalIcon = icon;
  }

  set focusIcon(icon) {
    this._focusIcon = icon;
  }

  /**
   * @param {DetailAction} value
   */
  set actionHandler(value) {
    value.owner = this;
    this._actionHandler = value;
  }

  /**
   * @param {Backend} value
   */
  set backend(value) {
    this._backend = value;
  }

  _focus() {
    this.tag('Label').color = Theme.Colors.Button.Primary.Focus.Text;
    this.tag('Background').shader.strokeColor = Theme.Colors.Button.Primary.Focus.Border;
    this.tag('Icon').src = this._focusIcon;
  }

  _unfocus() {
    this.tag('Label').color = Theme.Colors.Button.Primary.Normal.Text;
    this.tag('Background').shader.strokeColor = Theme.Colors.Button.Primary.Normal.Border;
    this.tag('Icon').src = this._normalIcon;
  }

  _handleEnter() {
    if (this._actionHandler && this._actionHandler.doAction) {
      this._actionHandler.doAction();
    } else {
      Log.error('[RatingButton]', 'No action associated with this rating button');
    }
  }
}
